<template>
  <el-menu-item class="timer-menu-item" index="timeCounter">
    <el-tooltip effect="dark" :content="tooltipContent" placement="bottom">
      <el-button :type="buttonType" :loading="stopping" :disabled="stopping" @click.stop="handleButtonClick">
        <header-menu-timer-counter :start="activeTimeLog.started_at"><i class="fas fa-stopwatch"></i></header-menu-timer-counter>
      </el-button>
    </el-tooltip>
  </el-menu-item>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import HeaderMenuTimerCounter from '@/components/HeaderMenuTimerCounter';
  import CalendarService from '@/services/calendarService';
  import { showSuccessMessage, showErrorMessage } from '@/ui/message';

  export default {
    name: 'HeaderMenuTimer',
    props: {
      activeTimeLog: {
        type: Object,
        required: true,
      },
    },
    components: {
      headerMenuTimerCounter: HeaderMenuTimerCounter,
    },
    computed: {
      ...mapGetters('entities/timeLogs', ['stopping']),

      over24Hours() {
        const diffParts = CalendarService.calculateTimeDiff(this.activeTimeLog.started_at);
        // console.log(diffParts);
        return diffParts.hours > 24;
      },

      buttonType() {
        return (this.over24Hours) ? 'danger' : 'success';
      },

      tooltipContent() {
        return (this.over24Hours) ? 'You have clocked in more than 24 hours ago.' : 'Click to stop.';
      },
    },
    methods: {
      ...mapActions('entities/timeLogs', ['stopTimer']),

      handleButtonClick() {
        if (this.over24Hours) {
          this.redirectToDashboard();
        } else {
          this.handleTimerStop();
        }
      },

      redirectToDashboard() {
        this.$router.go({ name: 'dashboard' });
      },

      handleTimerStop() {
        this.$confirm('Do you really want to clock out?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          title: 'Confirm',
        }).then(() => {
          this.stopTimer()
            .then((response) => {
              if (response.status) {
                showSuccessMessage('You have been clocked out successfully.');
              } else {
                showErrorMessage(response.error);
              }
            });
        });
      },
    },
  };
</script>

<style lang="scss">
  .timer-menu-item {
    .el-button--warning {
      i {
        color: #fff !important;
        font-size: 20px !important;
        margin-right: 5px;
      }

      &:hover {
        color: white;

        i {
          color: white;
        }
      }
    }

    .el-button--success {
      i {
        color: #fff !important;
        font-size: 20px !important;
        margin-right: 5px;
      }

      &:hover {
         color: white;

         i {
           color: white;
         }
       }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/HeaderMenuTimer.vue